module.exports = __webpack_public_path__ + "media/images/team/AnaMariaPereira-dea720be8e26450b86933ced4cf94989.png";